import { render, staticRenderFns } from "./SectionSummary.vue?vue&type=template&id=2fef3515&scoped=true&"
import script from "./SectionSummary.ts?vue&type=script&lang=ts&"
export * from "./SectionSummary.ts?vue&type=script&lang=ts&"
import style0 from "./SectionSummary.vue?vue&type=style&index=0&id=2fef3515&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef3515",
  null
  
)

export default component.exports